__turbopack_context__.v({
  "className": "titillium_web_2d2e7fe5-module__sErDHG__className",
  "variable": "titillium_web_2d2e7fe5-module__sErDHG__variable",
});
